import { 
// eslint-disable-next-line no-restricted-imports
combineEpics as combineEpicsReduxObservable, } from 'redux-observable';
import { catchError } from 'rxjs/operators';
import * as SentryService from 'web-app/services/sentry';
export const combineEpics = (...epics) => {
    return (action$, state$, dependencies) => {
        const mappedEpics = epics.map(epic => applyCatchErrorToEpic(epic, (error, source$) => {
            SentryService.captureException(error, { extra: { epicName: getFunctionName(epic) } });
            return source$;
        }));
        return combineEpicsReduxObservable(...mappedEpics)(action$, state$, dependencies);
    };
};
// Gets the function name, or returns <anonymous> if it's unnamed.
const getFunctionName = (fn) => (fn === null || fn === void 0 ? void 0 : fn.name) || `<anonymous>`;
// Extends an epic with error handling that doesn't manipulate the failing source
const applyCatchErrorToEpic = (epic, handleError) => (action$, state$, dependencies) => epic(action$, state$, dependencies).pipe(catchError(handleError));
